// src/pages/CampaignDashboard/modals/PromptSelectionModal.js

import React from 'react';

const PromptSelectionModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    promptData,
    selectedPrompt,
    onPromptSelect,
    isGenerateAction 
}) => {
    if (!isOpen) return null;

    const selectedPromptIndex = promptData.findIndex(p => p.prompt_id === selectedPrompt?.prompt_id);

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg w-1/2 shadow-lg">
                <div className="flex justify-between items-center mb-4">
                    <h1 className="text-xl font-bold">Prompt Box Selection</h1>
                    <button className="text-gray-500" onClick={onClose}>✖</button>
                </div>
                <p className="mb-4">Please select one of the prompts to generate an email below:</p>
                
                {promptData.length > 0 ? (
                    promptData.map((prompt, index) => (
                        <div
                            key={prompt.prompt_id}
                            className={`border-4 p-4 mb-4 rounded-lg cursor-pointer ${selectedPrompt?.prompt_id === prompt.prompt_id ? 'border-blue-500' : 'border-gray-300'}`}
                            onClick={() => onPromptSelect(prompt)}
                        >
                            <h2 className="text-lg font-semibold">Email Prompt Generation {index + 1}</h2>
                            <textarea
                                className="w-full mt-2 p-2 border rounded-lg"
                                rows="10"
                                value={prompt.prompt_content?.replace(/<br\s*\/?>/g, "\n") || ""}
                                readOnly
                            />
                        </div>
                    ))
                ) : (
                    <p className="text-gray-500">Loading prompts...</p>
                )}
                
                <div className="flex justify-between items-center mt-4">
                    <p className="text-gray-700">
                        {selectedPrompt ? `You have selected Prompt ${selectedPromptIndex + 1}` : "You have not selected any Prompt"}
                    </p>
                    <div className="flex gap-4">
                        <button className="px-4 py-2 bg-gray-300 rounded-full" onClick={onClose}>Cancel</button>
                        <button
                            className="px-4 py-2 bg-blue-500 text-white rounded-full disabled:opacity-50"
                            onClick={onConfirm}
                            disabled={!selectedPrompt}
                        >
                            {isGenerateAction ? "Start Generate" : "Confirm"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PromptSelectionModal;